import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Upload, Icon, Spin, message } from 'antd';
import cookies from 'js-cookie';

import { cookieNames } from '~constants';
import endpoints from '~settings/endpoints';

import useStyles from './style';

const { Dragger } = Upload;

const ImageComponent = ({ value, onChange }) => {
  const { content } = value;
  const classes = useStyles();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const buildAuthContractUrl = source => `${endpoints.getContractFile.url()}/${source}`;

  const uploadProps = {
    multiple: false,
    accept: '.jpg, .png, .jpeg',
    beforeUpload: file => {
      const isLt = file.size / 1024 / 1024 < 15;

      if (!isLt) {
        message.error(t('cms.upload.error_message.too_large'));
        return false;
      }

      const session = cookies.get(cookieNames.token);
      const formData = new FormData();
      const hasChinese = /[\u4E00-\u9FA5\uF900-\uFA2D]/g.test(file.name);
      let fileName = file.name;
      if (hasChinese) {
        switch (file.type) {
          case 'image/png':
            fileName = `${new Date().getTime()}.png`;
            break;
          case 'image/jpg':
            fileName = `${new Date().getTime()}.jpg`;
            break;
          case 'image/jpeg':
            fileName = `${new Date().getTime()}.jpeg`;
            break;
          default:
            fileName = `${new Date().getTime()}.png`;
        }
      }

      formData.append('document', file, fileName);

      setLoading(true);

      axios
        .post(`${endpoints.updateContractFile.url()}`, formData, {
          headers: {
            Authorization: `Bearer ${session}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          const url = buildAuthContractUrl(res.data.source);

          onChange(value.id, url);
        })
        .catch(err => {
          console.log('err: ', err);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  };

  return (
    <div className={classes.imageContainer}>
      <Choose>
        <When condition={loading}>
          <Spin />
        </When>
        <When condition={content}>
          <img src={content} />
        </When>
        <Otherwise>
          <Dragger {...uploadProps} showUploadList={false}>
            <div className={classes.wrapper}>
              <Icon type="picture" style={{ fontSize: 48, color: '#BFBFBF' }} />
              <p className={classes.uploadTitle}>{t('content.article.upload.notice')}</p>
              <p className={classes.uploadSummary}>{t('content.article.upload.summary.image')}</p>
            </div>
          </Dragger>
        </Otherwise>
      </Choose>
    </div>
  );
};

export default ImageComponent;
